<template>
  <div>
    <Header />
    <v-img
      :src="require('@/assets/bannerOtrosServicios.jpg')"
      :lazy-src="require('@/assets/carruselLazyLoad.jpg')"
    >
    </v-img>

    <v-row align="center" justify="center" no-gutters>
      <v-breadcrumbs :items="items" large>
        <template v-slot:divider>
          <v-icon>mdi-forward</v-icon>
        </template>
      </v-breadcrumbs>
    </v-row>

    <v-col cols="12">
      <v-row align="center" justify="center">
        <v-card
          class="pa-2"
          style="border: 0px solid white"
          width="700"
          outlined
          tile
        >
          <p
            class="fontTitle text-center mb-0"
            :class="[
              $vuetify.breakpoint.mdAndUp ? 'fontTitle' : 'subfontTitleResponsive',
            ]"
          >
            Ofrecemos una amplia gama de servicios y soluciones
          </p>
        </v-card>
      </v-row>
    </v-col>

    <v-sheet height="auto" width="100%">
      <v-container class="py-0">
        <v-row>
          <v-col cols="12" class="py-0">
            <v-row align="center" justify="center">
              <v-timeline
                align-top
                :dense="$vuetify.breakpoint.smAndDown"
                class="pt-0 mr-1"
              >
                <v-timeline-item
                  v-for="(item, i) in services"
                  :key="i"
                  :color="item.color"
                  :icon="item.icon"
                  fill-dot
                  data-aos="zoom-in-down"
                >
                  <v-card :color="item.color" dark>
                    <v-card-title :class="[$vuetify.breakpoint.mdAndUp ? 'fontTitleTimeline' : 'fontTitleTimelineResponsive',]">
                      <v-icon dark class="mr-1">{{item.iconTitle}}</v-icon>
                      Asistencia vial por
                    </v-card-title>
                    <v-card-text class="white black--text fontTitleTimeline">
                      <p class="font">
                        {{ item.title }}
                      </p>
                    </v-card-text>
                  </v-card>
                </v-timeline-item>
              </v-timeline>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-sheet>

    <ButtonScroll />
    <Footer />
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import Footer from "../components/Footer.vue";
import ButtonScroll from "../components/ButtonScroll.vue";

export default {
  data() {
    return {
      services: [
        {
          name: "Asistencia vial por",
          title: "REMOLQUE DE VEHICULO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia vial por",
          title: "CAMBIO DE LLANTA",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia vial por",
          title: "SUMINISTRO DE COMBUSTIBLE",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia vial por",
          title: "PASO DE CORRIENTE AL VEHICULO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia vial por",
          title: "CERRAJERIA VIAL-PROVEEDOR INTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia vial por",
          title: "CERRAJERIA VIAL-PROVEEDOR EXTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Inspección por",
          title: "COLISION O ACCIDENTE-PROVEEDOR INTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-file-signature"
        },
        {
          name: "Inspección por",
          title: "COLISION O ACCIDENTE- PROVEEDOR EXTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-file-signature"
        },
        {
          name: "Asistencia legal por",
          title:
            "ROBO TOTAL O PARCIAL MAS INSPECCION DE DAÑOS- PROVEEDOR INTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-balance-scale"
        },
        {
          name: "Asistencia legal por",
          title:
            "ROBO TOTAL O PARCIAL MAS INSPECCION DE DAÑOS- PROVEEDOR EXTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-balance-scale"
        },
        {
          name: "Asistencia legal",
          title:
            "HASTA LA AUDIENCIA INICIAL CON LESIONES EN TERCEROS CON PROVEEDOR INTERNO O EXTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-balance-scale"
        },
        {
          name: "Asistencia legal",
          title:
            "HASTA LA AUDIENCIA INICIAL POR HOMICIDIO CON PROVEEDOR INTERNO O EXTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-balance-scale"
        },
        {
          name: "Asistencia legal por",
          title:
            "LESIONES U HOMICIDIO CONCLUIDO EN PROCESO PENAL DESPUES DE LA AUDIENCIA INICIAL",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-balance-scale"
        },
        {
          name: "Asistencia por",
          title: "RETIRO DE VEHICULO EN PREDIO FISCAL O POLICIAL",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia por",
          title: "RETIRO DE PARTE POLICIAL EN SEDE FISCAL",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "far fa-handshake"
        },
        {
          name: "Asistencia por",
          title:
            "RECUPERACION JUDICIAL DE VEHICULO POR ROBO CON PROVEEDOR INTERNO O EXTERNO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia por",
          title: "CONCILIACION EXTRAJUDICIAL",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "far fa-handshake"
        },
        {
          name: "Asistencia por",
          title: "CONCILIACION EN SEDE FISCAL",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "far fa-handshake"
        },
        {
          name: "Asistencia por",
          title:
            "JUICIO CÍVIL DE TRANSITO (SUBROGACION POR DAÑOS MATERIALES EN EL VEHICULO ASEGURADO)",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-balance-scale"
        },
        {
          name: "Asistencia por",
          title:
            "CONCILIACIÓN EXTRAJUDICIAL CUANDO NUESTRO AFILIADO ES VÍCTIMA DE ACCIDENTE",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "far fa-handshake"
        },
        {
          name: "Asistencia por",
          title:
            "REPRESENTACION JUDICIAL EN CALIDAD DE QUERELLANTE (CUANDO AFILIADO ES LA VICTIMA DEL ACCIDENTE DE TRANSITO)",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "far fa-handshake"
        },
        {
          name: "Asistencia por",
          title:
            "REPRESENTACION JUDICIAL AL AFILIADO EN CASO DE DEMANDA POR DAÑOS MATERIALES EN VEHÍCULO TERCERO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "far fa-handshake"
        },
        {
          name: "Asistencia por",
          title: "ELABORACION DE PODERES EN ESCRITURA PÚBLICA",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-file-signature"
        },
        {
          name: "Asistencia por",
          title: "COMPRAVENTA DE VEHICULOS AUTOMOTORES",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-file-signature"
        },
        {
          name: "Asistencia por",
          title: "ELABORACION DE ACTAS NOTARIALES EN EL LUGAR DEL EVENTO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-file-signature"
        },
        {
          name: "Asistencia por",
          title:
            "LEGALIZACION DE PODERES O DOCUMENTOS PARA ASISTENCIAS LEGALES EN EL EXTRANJERO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-file-signature"
        },
        {
          name: "Asistencia por",
          title: "RECUPERACION DE VEHICULOS EN EL EXTRANJERO",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia vial por",
          title: "MANIOBRAS PARA REMOLQUE DE VEHICULOS",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-car-side"
        },
        {
          name: "Asistencia por",
          title: "SERVICIO DE AJUSTES DE PRESUPUESTOS",
          icon: "fas fa-check-circle",
          color: "indigo",
          iconTitle: "fas fa-marker"
        },
      ],
      items: [
        {
          text: "HOME",
          disabled: false,
          href: "/",
        },
        {
          text: "OTROS SERVICIOS",
          disabled: true,
          href: "",
        },
      ],
    };
  },
  components: {
    Header,
    Footer,
    ButtonScroll,
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Zilla+Slab:ital,wght@1,700&display=swap");
@import url("https://fonts.googleapis.com/css2?family=EB+Garamond:wght@500&family=Zilla+Slab:ital,wght@1,700&display=swap");

.fontTitle {
  font-family: "EB Garamond", serif;
  font-size: 30px;
}
.subfontTitleResponsive {
    font-family: "EB Garamond", serif;
    font-size: 20px;
}
.fontTitleTimeline {
  font-family: "Zilla Slab", serif;
    font-size: 20px;
}
.fontTitleTimelineResponsive {
  font-family: "Zilla Slab", serif;
    font-size: 15px;
}
</style>
